<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs6 offset-xs3>
        <h1>Login</h1>
        <v-text-field
        
          placeholder="Email"
          :value="emailLogin"
          @input="setEmailLogin();"
          counter="64"
        ></v-text-field>
        <v-text-field
         
          type="password"
          autocomplete="new-password"
          placeholder="Password"
          :value="passwordLogin"
          @input="setPasswordLogin"
        ></v-text-field>   
        <v-alert type="error" :value="loginError">{{loginError}}</v-alert>
     
        <v-btn color="green" @click="login" dark>Login</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  components: {},
  data () {
    return {
    emailLogin: ""
      }
    },
  computed: {
    ...mapState("authentication", ["emailLogin", "passwordLogin", "loginError"])
  },
  methods: {
    ...mapActions("authentication", ["login"]),
    ...mapMutations("authentication", [
      "setEmailLogin",
      "setPasswordLogin"
    ]),
    setEmailLogin2(){
        console.log(this.emailLogin);
    }
  }
};
</script>
